module.exports = __webpack_public_path__ + "img/content_partnership_bg.313f0221.jpg";